module.exports = __webpack_public_path__ + "static/media/bg.655bf24e.png";